import { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { OptionTypes, StartUpInfo, initialStartUpInfo, ModalType } from '../../../../../../types/types'
import { StartUpStepperContext } from '../../StartUpStepperContext';
import { sdi_regex, vat_regex } from '../../../../../../../shared/const';
import YupPassword from 'yup-password'
import clsx from 'clsx';
import { customStyles } from '../../../../../../../shared/style';
import Select, { SingleValue, StylesConfig } from 'react-select';
import { Logo } from '../../../../../../atoms';
import { StepperHeader } from '../../../sharedComponents';
import useMediaQuery from '../../../../../../../hook/useMediaQuery';
import { MediaMobile, MediaTablet } from '../../../../../../../api/const/MediaQuery';
import './StepperStartUp.css';
import { ConstitutionStatusOption } from 'components/types';
import { postAddressByGoogle, postCitiesList } from 'api/Api';
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';
import { useDebounce } from 'shared/hook/useDebounce';
import { Address, UserAddressReq } from 'components/types/Api';

YupPassword(Yup)

const startUpInfoSchema = Yup.object().shape({
  startUpName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  state: Yup.object().shape({
    value: Yup.string().required('Please select an option from the dropdown menu.')
  }).required('Please select an option from the dropdown menu.'),
  sector: Yup.object().shape({
    value: Yup.string().required('Please select an option from the dropdown menu.')
  }).required('Please select an option from the dropdown menu.'),
  vatNumber: Yup.string()
    .when('address', {
      is: (address: Address) => !!address?.isInItaly,
      then: Yup.string()
        .matches(vat_regex, 'VAT not correct')
        .required('Please complete this required field.'),
      otherwise: Yup.string().required('Please complete this required field.')
    }),
  address: Yup.object().shape({
    value: Yup.string()
      .required('Please complete this required field.'),
  }),
  sdi: Yup
    .string()
    .matches(sdi_regex, 'Incorrect SDI format')
    // .when("address", {
    //   is: (address: Address) => !!address?.isInItaly,
    //   then: Yup.string()
    //     .required("Must enter SDI code")
    // })
    ,
});

export const StepStartUpInfo = (props: any) => {
  const ctx = useContext(StartUpStepperContext);
  const tablet = useMediaQuery(MediaTablet)
  const mobile = useMediaQuery(MediaMobile)
  const { setErrorModal } = useContext(AppGeneralContext);

  const [startUpInfo] = useState<StartUpInfo>({
    ...initialStartUpInfo,
  });

  const formik = useFormik<StartUpInfo>({
    initialValues: startUpInfo,
    validationSchema: startUpInfoSchema,
    onSubmit: async (values) => {
      ctx.setStartUpName(values.startUpName);
      // ctx.setWebSite(values.website);
      ctx.setCompanyName(values.companyName);
      ctx.setVatNumber(values.vatNumber);
      ctx.setAddress(values.address);
      ctx.setCity(values.city.value);
      ctx.setSdi(values.sdi);
      ctx.setPec(values.pec);
      ctx.setState(values.state);
      ctx.setSector(values.sector);
      props.nextStep()
    }
  })

  const [addressFound, setAddressFound] = useState<Address[]>([]);
  const [searchedAddress, setSearchAddress] = useState<string>("")
  const [addressFoundIsLoading, setAddressFoundIsLoading] = useState<boolean>(false)
  const debouncedSearchAddress = useDebounce(searchedAddress, 500);

  useEffect(() => {
    if (!formik.values.address?.isInItaly) {
      formik.setFieldValue('sdi', '');
    }
  }, [formik.values.address.isInItaly])

  useEffect(() => {
    // setAddressFound([])

    if (!debouncedSearchAddress) {
      return;
    }

    console.log({ debouncedSearchAddress });

    const request = {
      address: debouncedSearchAddress
    } as UserAddressReq;
    setAddressFoundIsLoading(true);
    postAddressByGoogle(request).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error);
        return false;
      }

      const responseData = res.response.data;
      if (!Array.isArray(responseData)) {
        setErrorModal("Response data is not an array.");
        return false;
      }

      console.log({ responseData });

      setAddressFound(responseData);

      setAddressFoundIsLoading(false);

    });
  }, [debouncedSearchAddress, setErrorModal]);


  // useEffect(() => {
  //   if (city.length >= 3) {
  //     postCitiesList({ data: city }).then((res) => {

  //       if (!res.isSuccess || !res.response) {
  //         setErrorModal(res.error)
  //         return false
  //       }

  //       const response = res.response.data
  //       setCities(response)
  //     })
  //   } else {
  //     setCities([])
  //   }
  // }, [city.length])


  // useEffect(() => {
  //   postCitiesList({ data: city }).then((res) => {

  //     if (!res.isSuccess || !res.response) {
  //       setErrorModal(res.error)
  //       return false
  //     }

  //     const response = res.response.data
  //     setCities(response)
  //   })


  // }, [])

  return (
    <div
      className={clsx(
        'pe-3 mt-3 ',
        { 'd-none': !props.isActive },

      )} >
      <StepperHeader stepperTitle='Startup Info' />
      <form onSubmit={formik.handleSubmit} autoComplete='off'>
        {/* startUpName*/}
        <label className="text-black mt-3" htmlFor="startUpName">
          Startup Name
          <sup className="text-error" style={{ fontSize: "16px" }}>
            *
          </sup>
        </label>
        <input
          autoComplete="off"
          placeholder="Startup Name"
          {...formik.getFieldProps("startUpName")}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("startUpName", true)}
          value={formik.values.startUpName}
          name="startUpName"
        />
        {formik.errors.startUpName && formik.touched.startUpName && (
          <div className="text-error" id="startUpName">
            {formik.errors.startUpName}
          </div>
        )}

        {/* website */}
        {/* <label className="text-black mt-3" htmlFor="website">
          Website
          <sup className="text-error" style={{ fontSize: "16px" }}>
            *
          </sup>
        </label>
        <input
          placeholder="Website"
          {...formik.getFieldProps("website")}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("website", true)}
          value={formik.values.website}
          name="website"
        />
        {formik.errors.website && formik.touched.website && (
          <div className="text-error" id="website">
            {formik.errors.website}
          </div>
        )} */}

        {/*Industry */}
        <label className='text-black mt-3' htmlFor="state">
          Company Industry<sup className='text-error' style={{ fontSize: "16px" }}>*</sup>
        </label>

        <Select
          className='w-100'
          {...formik.getFieldProps('sector')}
          onChange={option => formik.setFieldValue('sector', option)}
          onBlur={() => formik.setFieldTouched("sector", true)}
          options={ctx.sectors}
          captureMenuScroll={true}
          placeholder='Select your Industry'
          styles={customStyles}
          value={!!formik.values.sector.value ? formik.values.sector : null}
          components={{ IndicatorSeparator: () => null }}
        />
        {formik.errors.sector && formik.touched.sector && <div className='text-error ms-2' id="sector">{formik.errors.sector.value}</div>}

        {/* Status */}
        <label className='text-black mt-3' htmlFor="state">
          Company Status<sup className='text-error' style={{ fontSize: "16px" }}>*</sup>
        </label>

        <Select<ConstitutionStatusOption>
          className='w-100'
          {...formik.getFieldProps('state')}
          onChange={(option: SingleValue<ConstitutionStatusOption>) => {
            formik.setFieldValue('state', option)
          }}
          onBlur={() => formik.setFieldTouched("state", true)}
          options={ctx.constitutionStatuses}
          captureMenuScroll={true}
          placeholder='Select your status'
          styles={customStyles as StylesConfig<ConstitutionStatusOption>}
          value={!!formik.values.state.value ? formik.values.state : null}
          components={{ IndicatorSeparator: () => null }}
        />
        {formik.errors.state && formik.touched.state && <div className='text-error ms-2' id="option">{formik.errors.state.value}</div>}

        {/* vatNumber */}
        <label
          className={clsx('text-black mt-3')}
          htmlFor="vatNumber">VAT number<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="off"
          placeholder='Your VAT number'
          {...formik.getFieldProps('vatNumber')}
          className={clsx('form-input')}
          type="tel"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("vatNumber", true)}
          value={formik.values.vatNumber}
          name="vatNumber"
        />
        {formik.errors.vatNumber && formik.touched.vatNumber && <div className='text-error ms-2' id="vatNumber">{formik.errors.vatNumber}</div>}
        <label
          className={clsx('text-black mt-3')}
          htmlFor="address">Address<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <Select
          placeholder='Address'
          value={formik.values.address}
          onInputChange={(value) => setSearchAddress(value)}
          onChange={(option) => {
            // Update city and country values based on the selected address
            // if (option && option.city && option.country) {
            //   formik.setFieldValue('city', { value: option.city, label: option.city });
            //   formik.setFieldValue('country', { value: option.country, label: option.country });
            //   setCity(option.city); // Update city state
            //   setCountry(option.country); // Update country state
            // }
            formik.setFieldValue('address', option); // Set selected address
          }}
          onBlur={() => {
            formik.setFieldTouched("address", true)
            setAddressFound([])
          }}
          isSearchable={true}
          isLoading={addressFoundIsLoading}
          filterOption={() => true}
          components={{
            IndicatorSeparator: () => null
          }}
          name='Address'
          noOptionsMessage={(inputValue) => 'Please enter an Address'}
          options={addressFound}
        />

        {formik.errors.address && formik.touched.address && <div className='text-error ms-2' id="address">{formik.errors.address.value}</div>}

        {/* Complete Address With Country */}
        {/* <div className="form-row">
          <div className="form-group col-md-6 d-inline">
            <label htmlFor="inputCity">City</label>
            <input
              type="text"
              className="form-control"

              id="inputCity"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder='City'
            />
          </div>
          <div className="form-group col-md-4 d-inline">
            <label htmlFor="inputState">Country</label>
            <input
              type="text"
              className="form-control"
              placeholder='Country'
              id="inputState"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>
        </div> */}

        {/* sdi */}
        <label className={clsx('text-black mt-3')}
          htmlFor="sdi">{"SDI (Italian companies only)"}
          <span style={{ fontSize: "12px" }}> </span>
          {/* <span className='text-error' id="sdi"><sup className='text-error' style={{ fontSize: "16px" }}>*</sup></span> */}
        </label>
        <input
          autoComplete="off"
          placeholder='SDI'
          {...formik.getFieldProps('sdi')}
          className={clsx('form-input')}
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("sdi", true)}
          value={formik.values.sdi}
          name="sdi"
          disabled={!formik.values.address?.isInItaly} // Disable SID field if country is not Italy
        />
        {formik.errors.sdi && formik.touched.sdi && <div className='text-error ms-2' id="sdi">{formik.errors.sdi}</div>}

        <div className="d-flex flex-row justify-content-between mt-4 mb-4  stepper_navigator">
          <button className="w-100 stepper_navigator_btn d-flex justify-content-start  align-items-center "
            type='button'
            onClick={() => props.previousStep()} >
            <Logo className="w-20 first me-2 rotate-180 " colorLogo="#FF3F6B" />
            <span> Back </span>
          </button>
          <div className="ms-5 me-5" />
          <button className={clsx(" stepper_navigator_btn w-100 d-flex justify-content-end align-items-center ",
            { "btn-disabled": formik.isSubmitting || !formik.isValid || !formik.touched })}
            disabled={
              !formik.isValid
              || !formik.touched
            }
            type='submit'
          >
            <span>Next</span>
            <Logo className="w-20 first ms-2" colorLogo={"#FF3F6B"} />
          </button>

        </div>
      </form>
    </div>
  );
};
